import * as types from '../constants/ActionTypes-ticket';


export const setTickets = tickets => ({
  type: types.SET_TICKETS,
  payload: tickets,
  reducer_type: 'reducer_ticket'
});

export const fetchItems = () => ({
  type: types.FETCH_ITEMS,
  reducer_type: 'reducer_ticket'
});
  
  export const addItem = newItem => {
    return {
      type: types.ADD_ITEM,
      payload: newItem,
      reducer_type: 'reducer_ticket'
    };
  };
  export const addDocumentFlag = id => {
    return {
      type: types.ADD_DOCUMENT_FLAG,
      payload: id,
      reducer_type: 'reducer_ticket'
    };
  };
  export const deleteItem = id => {
    return {
      type: types.DELETE_ITEM,
      payload: id,
      reducer_type: 'reducer_ticket'
    };
  };
  
  export const saveItem = updatedItem => {
    return {
      type: types.SAVE_ITEM,
      payload: updatedItem,
      reducer_type: 'reducer_ticket'
    };
  };
